<template>
  <div class="login-container">
    
    <iframe
      src="/GoogleLogin.html"
      frameborder="0"
      allow="identity-credentials-get"
      :style="{ width: '100%', height: '100%' }"></iframe>
    <Bug></Bug>
  </div>
</template>
<script>
import Bug from '../../components/Bug.vue'
import api from "@/common/api.js";

export default {
  data() {
    return {
    };
  },
  components:{
    Bug
  },
  methods: {
    
  },
  created() {
    // if (localStorage.userInfo) {
    //   router.push({ path: '/' })
    // } else {
      window.addEventListener('message', event => {
        if (event.data.token !== '' && event.data.status === true) {
          //  登录成功 将token发送给后端 获取返回信息 并跳转到首页
          this.$post(api.user.loginByMail, {
            idtoken: event.data.token,
          }).then((res) => {
            if (res.code === 200) {
                // console.log(res)
                localStorage.impr_id = res.list.employee_id;
                localStorage.impr_picture = res.list.profile_picture;
                localStorage.impr_token = res.list.token;
                this.$message.success(res.msg);
                this.$router.push({ path: "/" });
            }else {
                this.$message.error(res.msg);
            }
          })
        }
      })
    // }
  }
}
</script>
<style scoped>
  .login-container {
    width: 100%;
    height: 100vh;
    background: #EFF2F5;
  }
</style>